export enum EActionTypes {
  Set = 'currentRealtor/set',
  Reset = 'currentRealtor/reset',
}
